import { apiSlice } from "../../app/api/apiSlice";

export const getStandardDocumentUploadUrlApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getStandardDocumentUploadUrl: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/loan/get_standard_document_upload_url/",
				method: "POST",
				body: {
					loan_guid: credentials?.loanGuid,
					file_name: credentials?.fileName,
					file_size: credentials?.fileSize,
					user_email: String(credentials?.user_email ?? "").trim(),
				},
			}),
		}),
	}),
});

export const { useGetStandardDocumentUploadUrlMutation } =
	getStandardDocumentUploadUrlApiSlice;
